export default __webpack_public_path__ + "exp-icon28ae247.png";